module.exports = __webpack_public_path__ + "static/media/SF_bm_sentrert_logo_oslo_viken_neg.90f1acd4.pdf";